import { PartitionModal } from '../../../../i18n'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { EMPTY_STRING } from '../../Common/Constants/Separators'
import { IsVarEmpty, IsStringEmpty } from '../../../NonReact/utils/GlobalFunctions'
import { PARTITION_SYNC_TYPE } from '../Constants/Constants'

/**
 * Synchronisation type tag strings returned by the partition list admin API (WS
 * {@code ConvertIntegerValueToPartitionSyncTypeString} values).
 */
export const PARTITION_LIST_API_SYNC_TYPE_TAG = {
    SOFT: 'Soft',
    ONE_TIME_FULL: 'OneTimeFull',
    FULL: 'Full',
    SERVICE_PACK: 'ServicePack'
} as const

/**
 * Resolves the localised partition list cell label for {@code SyncType}.
 *
 * @param language - Language handler with {@link PartitionModal.NAME} loaded.
 * @param apiSyncType - Raw {@code SyncType} from the list API (tag or legacy {@link PARTITION_SYNC_TYPE} id string).
 * @returns Localised label; trimmed unknown non-empty values are returned as-is; empty or unset yields {@link EMPTY_STRING}.
 */
export const getPartitionListSyncTypeDisplayLabel = (
    language: CLanguageHandler,
    apiSyncType: Nullable<string>
): string => {
    if (IsVarEmpty(apiSyncType)) {
        return EMPTY_STRING
    }

    const normalized: string = String(apiSyncType).trim()

    if (IsStringEmpty(normalized)) {
        return EMPTY_STRING
    }

    switch (normalized) {
        case PARTITION_LIST_API_SYNC_TYPE_TAG.SOFT:
        case PARTITION_SYNC_TYPE.SOFT:
            return language.get(PartitionModal.PartitionModal_Sync_SynchronisationType_Soft)
        case PARTITION_LIST_API_SYNC_TYPE_TAG.ONE_TIME_FULL:
        case PARTITION_SYNC_TYPE.ONE_TIME_FULL:
            return language.get(PartitionModal.PartitionModal_Sync_SynchronisationType_OneTimeFull)
        case PARTITION_LIST_API_SYNC_TYPE_TAG.FULL:
        case PARTITION_SYNC_TYPE.FULL:
            return language.get(PartitionModal.PartitionModal_Sync_SynchronisationType_Full)
        case PARTITION_LIST_API_SYNC_TYPE_TAG.SERVICE_PACK:
        case PARTITION_SYNC_TYPE.SERVICE_PACK:
            return language.get(PartitionModal.PartitionModal_Sync_SynchronisationType_ServicePack)
        default:
            return normalized
    }
}
